module.exports = __webpack_public_path__ + "img/Frame 3.8b7eb212.png";